import type { MyWindow } from "@/types/window"
import { useMainStore } from "@/stores/store"

type TrackedEventName =
    | "search_executed"
    | "layer_added"
    | "layer_failed"
    | "custom_layer_added"
    | "custom_layer_failed"
    | "tool_opened"
    | "print_successful"
    | "print_failed"
    | "preset_composition_used"
    | "user_composition_saved"
    | "user_composition_used"
    | "mode_switched"
    | "basemap_changed"
    | "related_app_opened"
    | "help_opened"
    | "share_link_created"
    | "feedback_submitted"
    | "navigated_to_geoportal"

export function initGoogleAnalytics() {
    const store = useMainStore()

    //if (!window.location.href.includes("localhost")) {
    const script = document.createElement("script")
    script.setAttribute(
        "src",
        "https://www.googletagmanager.com/gtag/js?id=" + store.gaId
    )
    document.getElementsByTagName("head")[0]?.appendChild(script)
    ;(window as unknown as MyWindow).dataLayer =
        (window as unknown as MyWindow).dataLayer || []
    // @ts-expect-error: with types it doesn't work for some reason, but it works without
    gtag("js", new Date())
    // @ts-expect-error: with types it doesn't work for some reason, but it works without
    gtag("config", store.gaId, {
        send_page_view: false,
    })
    // @ts-expect-error: with types it doesn't work for some reason, but it works without
    gtag("event", "page_view")

    // console.log("GA active with ID: " + store.gaId)
    //}
}

export function trackEvent(
    eventName: TrackedEventName,
    eventParams?: Record<string, string>
) {
    const store = useMainStore()
    const hasConsent = store.cookiesPermissions?.analytical
    if (!hasConsent) {
        return
    }

    // @ts-expect-error: with types it doesn't work for some reason, but it works without
    gtag("event", eventName, eventParams)
}

function gtag() {
    ;(window as unknown as MyWindow).dataLayer.push(arguments)
}
